import type { Row } from '@tanstack/react-table';
import { ChevronDown, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';

export interface ExpandableRowProps<T> {
  row: Row<T>;
}

export const ExpandableRow = <T,>({ row }: ExpandableRowProps<T>) =>
  row.getCanExpand() ? (
    <Button
      variant={'ghost'}
      onClick={row.getToggleExpandedHandler()}
      style={{ cursor: 'pointer' }}>
      <Button.Icon icon>
        {row.getIsExpanded() ? <ChevronDown /> : <ChevronRight />}
      </Button.Icon>
    </Button>
  ) : null;
